import {
  AppRoutesPaths,
  DashboardType,
  LAST_SELECTED_DASHBOARD,
} from '@/common/constants';
import { AccessBlockedPanel } from '@/components/custom-roles';
import { useAppDispatch, useAppSelector } from '@/hooks/store';
import { NotFoundPage } from '@/pages/not-found';
import { setCurrentDashboard } from '@/store/features/dashboard';
import { selectCurrentUserCustomRoleCeiling } from '@/store/features/users';
import React, { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const BlockedPageContainer = styled.div`
  display: flex;
  min-height: 100%;
`;

export const UnmatchedRoutePage: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const customRoleCeiling = useAppSelector(selectCurrentUserCustomRoleCeiling);

  const isKnownRoute = Object.values(AppRoutesPaths).some((path) =>
    matchPath(path, location.pathname),
  );
  const isBlockedByRole = !!customRoleCeiling && isKnownRoute;

  useEffect(() => {
    if (!isBlockedByRole) {
      return;
    }

    localStorage.setItem(LAST_SELECTED_DASHBOARD, DashboardType.ADMIN);
    dispatch(setCurrentDashboard(DashboardType.ADMIN));
  }, [isBlockedByRole, dispatch]);

  return isBlockedByRole ? (
    <BlockedPageContainer>
      <AccessBlockedPanel variant="no-access" />
    </BlockedPageContainer>
  ) : (
    <NotFoundPage />
  );
};
